/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'back-arrow': {
    width: 14,
    height: 10,
    viewBox: '0 0 14 10',
    data: '<path pid="0" d="M1 5h12M5.667 9L1 5l4.667 4zM1 5l4.667-4L1 5z" _stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
